<template v-slot:default="formProps">
  <ds-form
    :on-submit="onSubmit"
    :form-refs="$refs"
    @canSubmit="setCanSubmit"
  >
    <template #default="formProps">
      <div
        class="vs-calculator"
        :dir="direction"
      >
        <div class="vs-input">
          <div class="vs-container">
            <div class="vs-row vs-justify-content-center">
              <div
                ref="erroralert"
                class="vs-col-12 vs-col-md-8"
                tabindex="-1"
              >
                <AppAlert
                  v-if="showApiError"
                  id="alert_form_submission"
                  :message="authorContent.serviceErrorMessage"
                />
              </div>
            </div>
            <div class="vs-row vs-align-items-center">
              <div class="vs-col-12 vs-col-md-6 vs-col-lg-4">
                <div class="vs-calculator-label">
                  <div
                    class="vs-row vs-align-items-center"
                    :class="{ 'vs-justify-content-end': !isMobile }"
                  >
                    <div class="vs-col-auto">
                      <label
                        class="vs-label vs-margin-0"
                        for="input_amount_paid"
                      >
                        {{ authorContent.amountLabel }}
                      </label>
                    </div>
                    <div class="vs-col-auto">
                      <Tooltip
                        :ally-open-label="authorContent.amountOpenAriaLabel"
                        :ally-close-label="authorContent.amountCloseAriaLabel"
                        :tooltip-header="authorContent.amountHelpTextHeader"
                        :tooltip-body="authorContent.amountHelpText"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="vs-col-12 vs-col-md-5 vs-col-lg-4">
                <div
                  class="vs-input-group vs-calculator-input-group"
                  :dir="direction"
                >
                  <Input
                    id="amount_paid"
                    :ref="formProps.formRef + 'amountPaid'"
                    v-model="calculator_form.amountPaid"
                    type="text"
                    max-length="16"
                    :placeholder="authorContent.amountPlaceholder"
                    :error-message="inputAmountValidationError"
                    :validators="[amountValidator]"
                    :dir="direction"
                    @onChange="formProps.onChange"
                  />
                </div>
              </div>
            </div>
            <div
              class="vs-row vs-align-items-center"
              role="group"
              aria-labelledby="currenciesLabel"
            >
              <div class="vs-col-12 vs-col-md-6 vs-col-lg-4">
                <div class="vs-calculator-label">
                  <div
                    class="vs-row vs-align-items-center"
                    :class="{ 'vs-justify-content-end': !isMobile }"
                  >
                    <div class="vs-col-auto">
                      <label
                        id="currenciesLabel"
                        class="vs-label vs-margin-0"
                      >
                        {{ authorContent.currenciesLabel }}
                      </label>
                    </div>
                    <div class="vs-col-auto">
                      <Tooltip
                        :ally-open-label="authorContent.currenciesOpenAriaLabel"
                        :ally-close-label="
                          authorContent.currenciesCloseAriaLabel
                        "
                        :tooltip-header="authorContent.currenciesHelpTextHeader"
                        :tooltip-body="authorContent.currenciesHelpText"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="vs-col-12 vs-col-md-5 vs-col-lg-4">
                <div class="vs-input-group vs-calculator-input-group">
                  <div class="vs-row">
                    <div
                      class="vs-col-5 vs-currency-dropdown-left vs-order-first"
                    >
                      <currency-list
                        id="from"
                        :ref="formProps.formRef + 'fromField'"
                        v-model="calculator_form.from"
                        :currency-list="currencyList"
                        :featured-currency-list="featuredCurrencyList"
                        :currency-label="authorContent.fromLabel"
                        :featured-label="authorContent.groupLabelRecent"
                        :non-featured-label="authorContent.groupLabelCurrency"
                        :clear-button-label="authorContent.fromButtonClearLabel"
                        :dropdown-button-close-label="
                          authorContent.currenciesFromDropDownCloseAriaLabel
                        "
                        :dropdown-button-open-label="
                          authorContent.currenciesFromDropDownOpenAriaLabel
                        "
                        :default-value="authorContent.defaultFromCurrency"
                        :error-message="authorContent.fromFieldValidator"
                        @onChange="formProps.onChange"
                      />
                    </div>
                    <div
                      class="vs-col-5 vs-currency-dropdown-right vs-order-last"
                    >
                      <currency-list
                        id="to"
                        :ref="formProps.formRef + 'toField'"
                        v-model="calculator_form.to"
                        :currency-list="currencyList"
                        :featured-currency-list="featuredCurrencyList"
                        :currency-label="authorContent.toLabel"
                        :featured-label="authorContent.groupLabelRecent"
                        :non-featured-label="authorContent.groupLabelCurrency"
                        :clear-button-label="authorContent.toButtonClearLabel"
                        :dropdown-button-close-label="
                          authorContent.currenciesToDropDownCloseAriaLabel
                        "
                        :dropdown-button-open-label="
                          authorContent.currenciesToDropDownOpenAriaLabel
                        "
                        :default-value="authorContent.defaultToCurrency"
                        :error-message="authorContent.toFieldValidator"
                        @onChange="formProps.onChange"
                      />
                    </div>
                    <div class="vs-col-2 vs-btn-swap-wrapper">
                      <button
                        class="vs-btn vs-btn-swap"
                        :aria-label="parsedSwapArialLabelText"
                        type="button"
                        :disabled="!canSwap"
                        :aria-hidden="!canSwap"
                        @click="onclick_swap()"
                      >
                        <span
                          aria-hidden="true"
                          class="visa-icon visa-icon-transactions-md"
                        />
                      </button>
                    </div>
                  </div>
                  <InlineAlert
                    v-if="!calculatorFormData.isValid"
                    id="input_alert_from_to"
                    :message="calculatorFormData.message"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="isConsolidated"
            class="vs-consolidated-section"
          >
            <div class="vs-container">
              <div class="vs-row vs-justify-content-center">
                <div class="vs-col-auto">
                  <span class="vs-text">{{ authorContent.dateFieldConsolidated }}
                  </span>
                  <span class="vs-text vs-bold">{{
                    calculator_form.date
                  }}</span>
                  <span class="vs-text">, {{ authorContent.bankFeeLabel }}
                  </span>
                  <span class="vs-text vs-bold">{{ authorContent.bankFee }}
                    {{ calculator_form.bankFee }}%</span>
                </div>
                <div class="vs-col-auto">
                  <button
                    type="button"
                    class="vs-link-cta vs-calculator-edit-link"
                    aria-label="edit date and bank rate"
                    @click="onclick_editlink()"
                  >
                    {{ authorContent.editLabel }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!isConsolidated"
            class="vs-container"
          >
            <div class="vs-row vs-align-items-center">
              <div class="vs-col-12 vs-col-md-6 vs-col-lg-4">
                <div class="vs-calculator-label">
                  <div
                    class="vs-row vs-align-items-center"
                    :class="{ 'vs-justify-content-end': !isMobile }"
                  >
                    <div class="vs-col-auto">
                      <label
                        class="vs-label vs-margin-0"
                        for="dateinput_date"
                      >
                        {{ authorContent.dateFieldLabel }}
                      </label>
                    </div>
                    <div class="vs-col-auto">
                      <Tooltip
                        :ally-open-label="authorContent.dateOpenAriaLabel"
                        :ally-close-label="authorContent.dateCloseAriaLabel"
                        :tooltip-header="authorContent.dateFieldHelpTextHeader"
                        :tooltip-body="authorContent.dateFieldHelpText"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="vs-col-12 vs-col-md-5 vs-col-lg-4">
                <div class="vs-input-group vs-calculator-input-group">
                  <DatePicker
                    id="date"
                    :ref="formProps.formRef + 'date'"
                    v-model="calculator_form.date"
                    :error-message="authorContent.dateFieldValidation"
                    :calendar-open-label="authorContent.calendarOpenAriaLabel"
                    :calendar-close-label="authorContent.calendarCloseAriaLabel"
                    :calandar-dialog="authorContent.calendarDialogAriaLabel"
                    :previous-month-icon-label="
                      authorContent.previousMonthAriaLabel
                    "
                    :next-month-icon-label="authorContent.nextMonthAriaLabel"
                    :date-placeholder="authorContent.dateFieldPlaceholder"
                    :calendar-close-text="authorContent.dateFieldCalendarClose"
                    :error-message-year="authorContent.dateFieldValidationYear"
                    :error-message-past-date="
                      authorContent.dateFieldValidationPast
                    "
                    @onChange="formProps.onChange"
                  />
                </div>
              </div>
            </div>
            <div class="vs-row vs-align-items-center">
              <div class="vs-col-12 vs-col-md-6 vs-col-lg-4">
                <div class="vs-calculator-label">
                  <div
                    class="vs-row vs-align-items-center"
                    :class="{ 'vs-justify-content-end': !isMobile }"
                  >
                    <div class="vs-col-auto">
                      <label
                        class="vs-label vs-margin-0"
                        for="input_bank_rate"
                      >
                        {{ authorContent.bankFeeLabel }}</label>
                    </div>
                    <div class="vs-col-auto">
                      <Tooltip
                        :ally-open-label="authorContent.bankFeeOpenAriaLabel"
                        :ally-close-label="authorContent.bankFeeCloseAriaLabel"
                        :tooltip-header="authorContent.bankFeeHelpTextHeader"
                        :tooltip-body="authorContent.bankFeeHelpText"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="vs-col-12 vs-col-md-5 vs-col-lg-4">
                <div class="vs-input-group vs-calculator-input-group">
                  <Input
                    id="bank_rate"
                    :ref="formProps.formRef + 'bankRate'"
                    v-model="calculator_form.bankFee"
                    type="text"
                    :validators="[amountValidator]"
                    :error-message="authorContent.bankFeeTextValidation"
                    @onChange="formProps.onChange"
                  />
                  <span
                    ref="bankrateicon"
                    class="vs-bank-rate-percent-icon vs-text"
                    :aria-label="authorContent.bankFeePercentageAriaLabel"
                  >
                    {{ authorContent.bankFeePercentage }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="vs-container">
            <div
              class="vs-row vs-align-items-center vs-justify-content-center vs-calculator-control"
            >
              <div class="vs-col-12 vs-col-md-auto">
                <button
                  type="button"
                  class="vs-btn vs-btn-primary"
                  style="display: inline-block"
                  :disabled="!isValid || !calculatorFormData.isValid"
                  @click="onSubmit"
                >
                  {{ authorContent.calculateButtonText }}
                </button>
              </div>
              <div class="vs-col-12 vs-col-md-auto">
                <div class="vs-row vs-justify-content-center">
                  <reset-form
                    :reset-label="authorContent.resetLabel"
                    @resetForm="onFormReset(formProps.resetForm)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <p
          v-if="!results"
          class="vs-text vs-legal vs-calculator-text"
        >
          {{ authorContent.disclaimerText }}
        </p>
        <div
          v-if="results"
          class="vs-output"
          dir="ltr"
        >
          <div class="vs-container">
            <h2
              class="vs-h2"
              aria-live="polite"
            >
              {{ results.conversionAmountValue }}
              {{ results.conversionToCurrency }} =
              <strong>{{ formattedConvertedAmount }}
                {{ results.conversionFromCurrency }}</strong>
            </h2>
            <p
              v-if="hasMarkup"
              class="vs-text vs-margin-0"
            >
              {{ authorContent.markupText }} {{ markupValue }}
            </p>
            <p class="vs-text vs-margin-0">
              1 {{ results.conversionToCurrency }} = {{ formattedFxRate }}
              {{ results.conversionFromCurrency }}
            </p>
            <p class="vs-text">
              1 {{ results.conversionFromCurrency }} =
              {{ formattedReverseAmount }} {{ results.conversionToCurrency }}
            </p>
            <p class="vs-text vs-legal">
              {{ parsedResultsText }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </ds-form>
</template>

<script>
import axios from 'axios';
import Input from '@/components/forms/input/Input.vue';
import AppAlert from '@/components/appAlert/AppAlert.vue';
import DatePicker from '@/components/forms/datePicker/DatePicker.vue';
import Tooltip from '@/components/tooltip/Tooltip.vue';
import CurrencyList from './components/CurrencyList';
import DsForm from '@/components/forms/form/Form';
import ResetForm from '@/components/forms/resetForm/ResetForm';
import dayjs from 'dayjs';
import { setDirection } from '@/helpers/direction';
import InlineAlert from '@/components/inlineAlert/InlineAlert.vue';

export default {
  name: 'DmCalculator',
  components: {
    Input,
    AppAlert,
    DatePicker,
    Tooltip,
    CurrencyList,
    DsForm,
    ResetForm,
    InlineAlert,
  },
  props: {
    content: { type: String, default: '' },
    direction: { type: String, default: setDirection() },
  },
  data() {
    return {
      results: '',
      showApiError: false,
      formattedConvertedAmount: 0,
      parsedResultsText: '',
      parsedContent: JSON.parse(this.content),
      isConsolidated: true,
      hasMarkup: false,
      markupValue: 0,
      calculator_form: {
        amountPaid: '',
        date: '',
        bankFee: '2',
        tooltip: 'test tooltip',
        from: '',
        to: '',
      },
      isMobile: false,
      isValid: false,
      formattedFxRate: 0,
      formattedReverseAmount: 0,
      inputAmountValidationError: '',
      amountTextMaxlengthValidation: 'Maximum 15 characters are allowed in the amount field text input.',
      sameToAndFromFieldValidation: 'From and To currencies can not be same. Please choose a different currency.'
    };
  },
  computed: {
    authorContent() {
      return this.parsedContent.authorContent;
    },
    calculatorFormData() {
      const { from, to } = this.calculator_form;
      const validationObject = {
        isValid: true,
        message: '',
      };

      if (from !== '' && to !== '' && from === to) {
        validationObject.isValid = false;
        validationObject.message = this?.authorContent?.sameToAndFromFieldValidation || this.sameToAndFromFieldValidation;
      }
      return validationObject;
    },
    currencyList() {
      return this.parsedContent.currencyList;
    },
    featuredCurrencyList() {
      return this.parsedContent.authorContent.mostUsedCurrencyList;
    },
    parsedSwapArialLabelText() {
      if (this.calculator_form.from.length && this.calculator_form.to.length) {
        return this.authorContent.swapButtonAriaLabel
          .replace('#{fromCurrency}', this.calculator_form.from)
          .replace('#{toCurrency}', this.calculator_form.to);
      } else {
        return null;
      }
    },
    canSwap() {
      return this.parsedSwapArialLabelText !== null;
    },
  },
  created() {
    this.calculator_form.date = dayjs().format('MM/DD/YYYY');
    this.calculator_form.bankFee = this.authorContent.bankFeePlaceholder;
    this.calculator_form.amountPaid = this.authorContent.defaultAmount || '';
  },
  mounted() {
    this.oninit();
    window.addEventListener('resize', this.oninit);
    this.oninit_appAlert();
  },
  unmounted() {
    window.removeEventListener('resize', this.oninit);
  },
  methods: {
    oninit() {
      this.isMobile = window.innerWidth < 768;
    },
    oninit_appAlert() {
      document.addEventListener('click_button_app_alert', (e) => {
        e.preventDefault();

        this.showApiError = false;
      });
    },
    onclick_editlink() {
      this.isConsolidated = !this.isConsolidated;
      this.initErcEngagement(
        'edit',
        'edit details',
        this.selectedCurrencyKey(this.calculator_form.from),
        this.selectedCurrencyKey(this.calculator_form.to)
      );

      const trackUserData = new CustomEvent('track_erc_links', {
        detail: {
          event: 'edit_date_fee',
          date: this.calculator_form.date,
          bankFee: this.calculator_form.bankFee,
        },
      });

      document.dispatchEvent(trackUserData);
    },
    onclick_swap() {
      const fromEl = this.$refs.formRef_fromField;
      const toEl = this.$refs.formRef_toField;
      const fromValue = this.calculator_form.from;
      const toValue = this.calculator_form.to;
      fromEl.setValue(toValue);
      toEl.setValue(fromValue);
      this.initErcEngagement(
        'swap',
        'swap currency',
        this.selectedCurrencyKey(this.calculator_form.from),
        this.selectedCurrencyKey(this.calculator_form.to)
      );
      const trackUserData = new CustomEvent('track_erc_links', {
        detail: {
          event: 'swap_currency',
          fromCurrency: this.selectedCurrencyKey(fromValue),
          toCurrency: this.selectedCurrencyKey(toValue),
        },
      });

      document.dispatchEvent(trackUserData);
    },
    amountValidator(val) {
      const expression = /^\d*\.?\d+$/;
      if (!expression.test(val)) {
        this.inputAmountValidationError =
          this.authorContent.amountTextValidation;
        return false;
      }
      if (val?.length > 15) {
        this.inputAmountValidationError = this.authorContent.amountTextMaxlengthValidation || this.amountTextMaxlengthValidation;
        return false;
      }
      return true;
    },
    formatDecimalPlaces(value, decimalPlaces) {
      var removeCommas = value.replaceAll(',', '');
      return parseFloat(removeCommas).toFixed(decimalPlaces);
    },
    formatMarkupValue(value) {
      var removeCommas = value.replaceAll(',', '');
      return (parseFloat(removeCommas) * 100).toFixed(2);
    },
    resultsText(date, fee) {
      var resultText = this.authorContent.resultsText;
      resultText = resultText.replace('#{submittedDate}', date);
      resultText = resultText.replace('#{submittedBankFee}', fee);
      return resultText;
    },
    selectedCurrencyKey(value) {
      let str = value.substring(0, value.indexOf('-'));

      if (str) {
        return str.trim();
      }
    },
    initErcEngagement(clickText, clickAction, fromCurrency, toCurrency) {
      var event = new CustomEvent('erc_engagement', {
        detail: {
          componentType: 'button',
          component: 'Exchange Rate Calculator',
          siteSection: 'erc',
          clickText: clickText,
          eventAction: clickAction,
          conversion_details: fromCurrency + ':' + toCurrency,
        },
      });
      document.dispatchEvent(event);
    },
    setCanSubmit(canSubmit) {
      this.isValid = canSubmit;
    },
    async onSubmit() {
      try {
        const response = await axios.get('/cmsapi/fx/rates', {
          params: {
            amount: this.calculator_form.amountPaid,
            fee: this.calculator_form.bankFee,
            utcConvertedDate: this.calculator_form.date,
            exchangedate: this.calculator_form.date,
            fromCurr: this.selectedCurrencyKey(this.calculator_form.to),
            toCurr: this.selectedCurrencyKey(this.calculator_form.from),
          },
        });
        if (response.data) {
          this.showApiError = false;
          this.results = response.data;
          this.formattedConvertedAmount = this.formatDecimalPlaces(
            this.results.convertedAmount,
            this.authorContent.decimalPointsInResult
          );
          this.parsedResultsText = this.resultsText(
            this.results.conversionInputDate,
            this.results.conversionBankFee
          );
          this.formattedFxRate = this.formatDecimalPlaces(
            this.results.fxRateWithAdditionalFee,
            this.authorContent.decimalPointsInResult
          );
          this.formattedReverseAmount = this.formatDecimalPlaces(
            this.results.reverseAmount,
            this.authorContent.decimalPointsInResult
          );
          if (this.results.originalValues.benchmarks.length != 0) {
            this.hasMarkup = true;
            this.markupValue = this.formatMarkupValue(
              this.results.originalValues.benchmarks[0].markupWithAdditionalFee
            );
          } else {
            this.hasMarkup = false;
          }
        }
        this.initErcEngagement(
          'calculate conversion',
          'calculate conversion',
          this.selectedCurrencyKey(this.calculator_form.from),
          this.selectedCurrencyKey(this.calculator_form.to)
        );
        const trackUserData = new CustomEvent('track_erc_links', {
          detail: {
            event: 'calculate_conversion',
            fromCurrency: this.selectedCurrencyKey(this.calculator_form.from),
            toCurrency: this.selectedCurrencyKey(this.calculator_form.to),
            date: this.calculator_form.date,
            bankFee: this.calculator_form.bankFee,
          },
        });

        document.dispatchEvent(trackUserData);
      } catch (err) {
        this.showApiError = true;
        this.$nextTick(() => {
          this.$refs.erroralert.focus();
        });

        const trackUserData = new CustomEvent('track_erc_links', {
          detail: {
            event: 'calculate_conversion_error',
            errorMessage: this.authorContent.serviceErrorMessage,
          },
        });

        document.dispatchEvent(trackUserData);
      }
    },
    onFormReset(resetForm) {
      this.initErcEngagement(
        'reset',
        'reset details',
        this.selectedCurrencyKey(this.calculator_form.from),
        this.selectedCurrencyKey(this.calculator_form.to)
      );
      const trackUserData = new CustomEvent('track_erc_links', {
        detail: {
          event: 'reset_details',
          fromCurrency: this.selectedCurrencyKey(this.calculator_form.from),
          toCurrency: this.selectedCurrencyKey(this.calculator_form.to),
          date: this.calculator_form.date,
          bankFee: this.calculator_form.bankFee,
        },
      });
      document.dispatchEvent(trackUserData);

      resetForm();
    }
  },
};
</script>

<style lang="scss" scoped>
@import './calculator';
@import '@/styles/core/types/types';
@import '@/styles/buttons/buttons';
@import '@/styles/links/erclinks';
@import '@/styles/grid';
@import '@/styles/forms';
@import '@/styles/input';
@import '@/styles/label';
@import '@/styles/utilities';
</style>

<style lang="scss">
@use '../../styles/mixins/breakpoints';

.vs-calculator {
  .vs-calculator-input-group {
    .vs-input-group {
      height: auto;
      margin-bottom: 20px;
    }
  }
  .vs-currency-dropdown-right {
    .vs-listbox {
      left: auto;
      right: 0;

      @include breakpoints.desktop-up {
        left: 0;
        right: auto;
      }
    }
  }
}
</style>